module.exports = __webpack_public_path__ + "img/list-icon-light.ef3ca068.svg";